//#region src/async-utils/resolve-after.ts
const resolveAfter = (milliseconds, withValue) => {
	return new Promise((res) => setTimeout(() => res(withValue), milliseconds));
};
//#endregion
export { resolveAfter };
